export default "__VITE_ASSET__L6yK$Sgn__"